export default {
  placeholder: 'Escreva sua anotação...',
  insert: 'Inserir Texto',
  button: {
    confirm: 'Confirmar',
  },
};
